/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryDetailsResponse } from './categoryDetailsResponse';

export interface CategoryResponse { 
    id: string;
    value?: string;
    type?: CategoryResponse.TypeEnum;
    details?: Array<CategoryDetailsResponse>;
}
export namespace CategoryResponse {
    export type TypeEnum = 'TRANSCRIPTIONS';
    export const TypeEnum = {
        TRANSCRIPTIONS: 'TRANSCRIPTIONS' as TypeEnum
    };
}